import CloseIcon from '@mui/icons-material/Close';
import { DialogTitle as MuiDialogTitle, IconButton } from '@mui/material';

export type DialogTitleProps = {
  showClose: boolean;
  id: string;
  children?: React.ReactNode;
  onClose?: (id: string) => void;
  disabled?: boolean;
  headerTitleColor?: string;
  headerBackgroundColor?: string;
};

export const DialogTitle = (props: DialogTitleProps) => {
  const {
    id,
    children,
    showClose,
    onClose,
    disabled,
    headerTitleColor,
    headerBackgroundColor,
    ...rest
  } = props;
  const onCloseHandler = () => {
    onClose && onClose(id);
  };

  return (
    <MuiDialogTitle
      data-testid={`dialog-${id}-dialogTitle`}
      sx={{
        fontWeight: 700,
        backgroundColor: `${headerBackgroundColor ? headerBackgroundColor : '#fff'}`,
        color: `${headerTitleColor ? headerTitleColor : '#333'}`,
      }}
      {...rest}
    >
      {children}
      {showClose && (
        <IconButton
          data-testid={`dialog-${id}-closeButton`}
          aria-label="close"
          disabled={disabled}
          onClick={onCloseHandler}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon data-testid={`dialog-${id}-closeIcon`} />
        </IconButton>
      )}
    </MuiDialogTitle>
  );
};
